var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-default button",attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.icon,"alt":"sort button"}})])}
var staticRenderFns = []

export { render, staticRenderFns }